module.exports = __webpack_public_path__ + "static/media/ZS.b882714c.pdf";